import { gql } from "@apollo/client";

const CORE_OBJECT_FIELDS = gql`
  fragment CoreObjectFields on MdmObjectDTO {
    id
    identifier
    title
    type
    latitude
    longitude
    fullAddress
    customFields {
      key
      value {
        type
        value
      }
    }
    deviceRelations {
      mdmDevice {
        identifier
      }
    }
  }
`;

const UPD_OBJECT_FIELDS = gql`
  fragment UpdObjectFields on MdmObjectDTO {
    id
    title
    identifier
    description
    tags
    type
    parentId
    city
    country
    houseNumber
    postCode
    street
    fullAddress
    latitude
    longitude
  }
`;

export const GET_OBJECTS_PAGED = gql`
  query GetObjectsPaged($input: ByProjectIdReqInput!) {
    ${CORE_OBJECT_FIELDS}
    mdmObjectsByProjectIdPaged(req: $input) {
      items {
        ...CoreObjectFields
        tags
      }
      pageInfo {
        skip, take, total
      }
    }
  }
`;

export const GET_ROOT_OBJECTS_PAGED = gql`
  query GetRootObjectsPaged($input: ByProjectIdReqInput!) {
    ${CORE_OBJECT_FIELDS}
    mdmRootObjectsByProjectIdPaged(req: $input) {
      items {
        ...CoreObjectFields
        tags
      }
      pageInfo {
        skip, take, total
      }
    }
  }
`;

export const GET_APARTMENTS_PAGED = gql`
  query GetApartmentsPaged($input: ByProjectIdReqInput!) {
    ${CORE_OBJECT_FIELDS}
    mdmApartmentsByProjectIdPaged(req: $input) {
      items {
        ...CoreObjectFields
        tags
      }
      pageInfo {
        skip, take, total
      }
    }
  }
`;

export const GET_SIMPLE_OBJECTS_BY_PROJECT = gql`
  query GetSimpleObjectsByProject($id: String!) {
    mdmObjectsByProjectId(projectId: $id) {
      id
      identifier
      fullAddress
    }
  }
`;

export const GET_OBJECTS_BY_PROJECT = gql`
  query GetObjectsByProject($id: String!){
    ${CORE_OBJECT_FIELDS}
    mdmObjectsByProjectId(projectId: $id) {
      ...CoreObjectFields
    }
  }
`;

export const GET_ROOT_OBJECTS_BY_PROJECT = gql`
  query GetRootObjectsByProject($id: String!){
    ${CORE_OBJECT_FIELDS}
    mdmRootObjectsByProjectId(projectId: $id) {
      ...CoreObjectFields
    }
  }
`;

export const GET_OBJECT = gql`
  query GetObject($id: String!) {
    ${UPD_OBJECT_FIELDS}
    mdmObjectById(id: $id) {
      ...UpdObjectFields
      customFields {
        key
        value {
          type
          value
        }
      }
      boundDatasets {
        all {
          dataset {
            identifier
            title
          }
        }
        indirect {
          dataset {
            identifier
            title
          }
        }
        direct {
          dataset {
            identifier
            title
          }
        }
        mapped {
          dataset {
            identifier
            title
          }
        }
      }
      deviceRelations {
        mdmDevice {
          id
          identifier
          tags
          modifiedAt
          createdAt
          status {
            status
            lastMeasurementDate
          }
          customFields {
            key
            value {
              type
              value
            }
          }
        }
        roleInObject
      }
      children {
        id
        identifier
        title
        fullAddress
        houseNumber
      }
      info {
        jobsCount
        notesCount
      }
    }
  }
`;

export const CREATE_OBJECT = gql`
  mutation CreateObject($object: MdmObjectDTOInput!) {
    ${UPD_OBJECT_FIELDS}
    createMdmObject(input: $object) {
      ...UpdObjectFields
    }
  }
`;

export const UPDATE_OBJECT = gql`
  mutation UpdateObject($object: MdmObjectDTOInput!) {
    ${UPD_OBJECT_FIELDS}
    updateMdmObject(input: $object) {
      ...UpdObjectFields
    }
  }
`;

export const DELETE_OBJECT = gql`
  mutation DeleteObject($id: String!) {
    deleteMdmObject(id: $id) {
      id
      identifier
      title
    }
  }
`;
